import { Spinner } from "react-bootstrap"

import NotificationSectionData from "../../../api/Notifications/Model/NotificationOptionsData"
import ToggleSwitch from "../../FormattedInputs/ToggleSwitch"

interface NotificationOptionsProps {
  description: string
  items: NotificationSectionData[]
  selectedIDs: number[]
  loading?: boolean
  onChange: (itemId: number, checked: boolean) => void
}

function NotificationOptions(props: NotificationOptionsProps) {
  const { description, items, selectedIDs, loading, onChange } = props

  return (
    <div className="w-50">
      <h4 className="mt-2">
        {description}&nbsp;{loading && <Spinner animation="border" variant="secondary" size="sm" className="mb-1" />}
      </h4>
      <table className="table table-sm">
        <tbody>
          {!loading &&
            items?.map((event) => (
              <tr key={event.Id}>
                <td className="align-middle">{event.Description}</td>
                <td className="pb-1 pt-2 text-right">
                  <ToggleSwitch
                    on="Yes"
                    off="No"
                    className="mb-0"
                    checked={selectedIDs.includes(event.Id)}
                    onCheck={(checked) => onChange(event.Id, checked)}
                  />
                </td>
              </tr>
            ))}
          {!loading && items?.length === 0 && (
            <tr>
              <td colSpan={2} className="text-muted">
                No available options found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

NotificationOptions.defaultProps = {
  loading: false,
}

export default NotificationOptions
